import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import { HiOutlineTrash } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';


export const ParsingRuleBasicInfoComponent = ({ deleteSelectedService, fieldConversions, organizationUnits, handleInnerBasicFormChange, handleInnerFormChange, parsingRule, tenantFunctions, handleFormItemChange }: any) => {

  const libraryData = useSelector(selectListItems)

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'Name',
                );
              }}
              type="text"
              value={parsingRule?.Name}
            />

            <InputContainer
              label="Owner Type "
              labelField="FunctionName"
              list={tenantFunctions}
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'OwnerTypeId',
                );
              }}
              optionName='Choose Owner Type'
              type="select"
              value={parsingRule?.OwnerTypeId}
              valueField="Id"
            />

            <InputContainer
              label="Limited To OrganizationUnit"
              labelField="IsLimitedToOrganizationUnit"
              onValueChange={(event: any) => {
                handleInnerBasicFormChange(
                  event,
                  'IsLimitedToOrganizationUnit',
                );
              }}
              type="checkbox"
              value={parsingRule?.IsLimitedToOrganizationUnit}
            />

            {parsingRule?.IsLimitedToOrganizationUnit === true && (

              <InputContainer
                label="Limited To OrganizationUnit "
                labelField="OrganizationUnitInfo.Name"
                list={organizationUnits}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'LimitedToOrganizationMappings.LimitedToOrganizationUnitIds',
                    parsingRule?.LimitedToOrganizationMappings,
                  );
                }}
                optionName='Choose OrganizationUnit'
                type="select"
                value={
                  parsingRule?.LimitedToOrganizationMappings
                    ?.LimitedToOrganizationUnitIds
                }
                valueField="OrganizationUnitInfo.Id"
              />

            )}
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Information"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Input File Type "
              labelField="Text"
              list={libraryData?.result?.FileFormatType}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Options.InputFileType',
                  parsingRule?.Options,
                );
              }}
              optionName='Choose Input FileType'
              type="select"
              value={parsingRule?.Options?.InputFileType}
              valueField="Text"
            />

            <InputContainer
              label="Output File Type "
              labelField="Text"
              list={libraryData?.result?.FileFormatType}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Options.OutputFileType',
                  parsingRule?.Options,
                );
              }}
              optionName='Choose Output FileType'
              type="select"
              value={parsingRule?.Options?.OutputFileType}
              valueField="Text"
            />

            <InputContainer
              label="Input File Has Header"
              labelField="InputFileHasHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'Options.InputFileHasHeader',
                  parsingRule?.Options,
                );
              }}
              type="checkbox"
              value={parsingRule?.Options?.InputFileHasHeader}
            />
          </div>
        }
        expandedPanel="Options"
        headerTitle="Options"
      />
      <AccordionContainer
        child={
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr>
                  <th className="px-4 py-2 border-b border-gray-300">Delete</th>
                  <th className="px-4 py-2 border-b border-gray-300">INPUTFIELD INDEX</th>
                  <th className="px-4 py-2 border-b border-gray-300">INPUTFIELD TYPE</th>
                  <th className="px-4 py-2 border-b border-gray-300">OUTPUTFIELD INDEX</th>
                  <th className="px-4 py-2 border-b border-gray-300">OUTPUTFIELD TYPE</th>
                  <th className="px-4 py-2 border-b border-gray-300">OUTPUTHEADER TEXT</th>
                </tr>
              </thead>
              <tbody>
                {_.map(fieldConversions, (cardValue, index) => (
                  <tr key={index} className="h-20">
                    <td className="px-4 py-2 border-b border-gray-300">
                      <button className="text-red-500 hover:text-red-700" onClick={async () => deleteSelectedService(cardValue, index)}>
                        <HiOutlineTrash className="w-6 h-6" />
                      </button>
                    </td>
                    <td className="px-4 py-2 border-b border-gray-300"><InputContainer
                      labelField="InputField Index"
                      onValueChange={(event: any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'InputFieldIndex',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.InputFieldIndex}
                    /></td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                        labelField="Text"
                        list={libraryData?.result?.FieldType}
                        onValueChange={(event: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'InputFieldType',
                            idx: index,
                          });
                        }}
                        type="text"
                        value={cardValue?.InputFieldType}
                        valueField="Text"
                      />
                    </td>
                    <td className="px-4 py-2 border-b border-gray-300"> <InputContainer
                      labelField="Output Field Index"
                      onValueChange={(event: any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'OutputFieldIndex',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.OutputFieldIndex}
                    /></td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                        labelField="Text"
                        list={libraryData?.result?.FieldType}
                        onValueChange={(event: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OutputFieldType',
                            idx: index,
                          });
                        }}
                        type="text"
                        value={cardValue?.OutputFieldType}
                        valueField="Text"
                      />
                    </td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                        labelField="OutputHeaderText"
                        onValueChange={(event: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OutputHeaderText',
                            idx: index,
                          });
                        }}
                        type="text"
                        value={cardValue?.OutputHeaderText}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
        expandedPanel="Field Conversions"
        headerTitle="Field Conversions"
      />
    </>
  )
}
export default ParsingRuleBasicInfoComponent;
